<!--
/**
  * 表单详情组件
  * @author weili
  */
-->
<template>
  <div class="con-box">
    <div v-for="(item, index) in contentArr" :key="index" class="each" :style="{width:item.width || '33.33%'}">
        <div v-if="!item.hide" style="display:flex">
          <div class="key" :style={width:labelWidth}
            >{{item.label}}{{item.hide ? '' : '：'}}
          </div>
          <!--图片-->
          <div class="value" v-if="item.type=='image'">
            <!-- <div v-for="row in fileArr[item.value]"  :key="row.id" style="display:inline;"> -->
            <!-- <img class="main-img" :style="item.imgStyle" :src="row.httpUrl" :alt="row.attachName" @click="lookImgFn(row)"/> -->
           <!-- <div style="display:inline;"> -->
             <EXPreview v-if="fileArr[item.value] && fileArr[item.value].length" :photosList="fileArr[item.value]"></EXPreview>
          <!-- </div>     -->
            <!-- </div> -->
          </div>
          <!--附件-->
          <div class="value" v-else-if="item.type=='file'">
            <div v-for="row in fileArr[item.value]"  :key="row.id">
              <span class="filename"  @click="downloadFile(row)">{{row.attachName}}</span>
              <span class="size">（{{row.fileSize}}kb）</span>
              <!-- <span class="filename" @click="previewFile(row)" v-if="row.fileType == 'pdf' || row.fileType == '.pdf' ||row.fileType == 'jpg' || row.fileType == '.jpg' || row.fileType == 'png' || row.fileType == '.png' || row.fileType == 'jpeg'  || row.fileType == '.jpeg'">- 预览</span> -->
              <!-- <span class="filename" @click="previewImg(row)" v-else-if="row.fileType == 'jpg' || row.fileType == '.jpg' || row.fileType == 'png' || row.fileType == '.png' || row.fileType == 'jpeg'  || row.fileType == '.jpeg'">- 预览</span> -->
            </div>
          </div>
          <!--备注文字-->
          <div class="value" v-else-if="item.type=='info'" :style="item.infoStyle" style="margin-left:-0.86rem">
              <div class="table-desc">
                <div class="tips">
                      <img alt="" />
                      <span style="color: #333; margin-left: 0.06rem"
                        >{{ item.info ? item.info : getObjectProperty(detailForm, item.value)}}</span>
                </div>
              </div>
          </div>
          <!--内容-->
          <div class="value" v-else :style="item.cssStyle" >
            <!--超链接-->
              <div v-if="item.link" class="links" @click="gotoLink(item)">
                <img alt="" />
                <el-tooltip :content="item.content?item.content:getObjectProperty(detailForm, item.value)" :placement="item.placement?item.placement:'right'" effect="dark">
                  <span>{{ getObjectProperty(detailForm, item.value) }}{{item.tag}}</span>
               </el-tooltip>
              </div>
              <span class="p" v-else>{{ getObjectProperty(detailForm, item.value) }}{{item.tag}}</span>
          </div>
        </div>
    </div>
    <el-divider v-if="contentSize>1 && contentIndex<contentSize-1"></el-divider> <!--多个详情数据添加分隔线-->
    <el-dialog :visible.sync="dialogVisible"  title="预览">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin'
import * as attachApi from '@/api/gate/attach/index'
export default {
  name: 'EXDetailContent',
  components: {
  },
  mixins: [mixin],
  props: {
    labelWidth: {
      type: String,
      default: "1.4rem",
    },
    contentArr: Array,
    detailForm: Object,
    span: {
      type: Number,
      default: 8,
    },
    contentIndex: {
      type: Number,
      default: 0,
    },
    contentSize: {
      type: Number,
      default: 1,
    },
     //fileArr直接赋值
     fileData:Object
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl:"",
      fileArr:{},
    };
  },
  created(){
    this.initAttachInfo()
  },
  mounted(){
    if(this.fileData && this.fileData.length > 0){
      this.fileArr = this.fileData;
    }
  },
  watch: {
    detailForm (val) {
      this.initAttachInfo()
    },
    contentArr(val) {
      this.initAttachInfo()
    },
    fileData (val) {
      this.fileArr = val;
    },
  },
  computed: {
    rowNum: {
      get() {
        return this.contentArr.length % 3 == 0
          ? this.contentArr.length % 3
          : (this.contentArr.length % 3) + 1;
      },
    },
  },
  methods:{
    downloadFile(file) {
      if (file) {
        // if(file.url){
        //   window.location.href = $config.downloadUrl + encodeURIComponent(file.url)+'&fileName='+encodeURIComponent(file.name)
        // }else{
          window.location.href = $config.downloadUrl + encodeURIComponent(file.filePath)+'&fileName='+encodeURIComponent(file.attachName)
        // }
        // window.location.href = $config.downloadUrl + encodeURIComponent(file.filePath)
      }
    },
    lookImgFn(row){
        this.dialogVisible = true
        this.dialogImageUrl = row.httpUrl
    },
    convertFileSize(fileSize){
      return Math.round(fileSize/1024)
    },
    gotoLink(item){
      if(item.link && typeof item.link === "function"){
        item.link()
      }
    },
    getObjectProperty(obj, str){
      str = str.replace(/\[(\w+)\]/g, ".$1"); // 处理数组下标
      let arr = str.split(".");
      for (let i in arr) {
        if(obj){
          obj = obj[arr[i]];
        }
      }
      return obj;
    },
    initAttachInfo(){
     this.contentArr.map((item) => {
        if(item.objectId && item.objectId != '' && item.objectType && item.objectType != ''){ //附件类型
                    const params = {
                      objectId: this.getObjectProperty(this.detailForm, item.objectId),
                      objectNamespace : item.objectType
                    }
                    console.log("params",params)
                    if(params.objectId && params.objectNamespace){
                      attachApi.getAttachmentList(params).then((res)=>{
                          let body = res && res.body ? res.body : null
                          if(!body){
                            let data = res && res.data ? res.data : {}
                            body = data && data.body ? data.body : {}
                          }
                          const list = body.list || []
                          if(item.type == 'image'){
                            this.$set(this.fileArr, item.value, list.map((e)=>({
                              attachName: e.attachName,
                              filePath: e.filePath,
                              // httpUrl:rootUrl+e.filePath,        //httpUrl转换
                              fileType: e.attachType,
                              fileSize: this.convertFileSize(e.attachSize)     //文件单位转换
                            })));
                            let photosList = []
                            list.map((e)=>{
                              photosList.push({
                                  filePath: e.filePath,
                                  createDate: '',
                                  fileType: e.fileType,
                              })
                            })
                            this.$set(this.fileArr, item.value, photosList)
                          console.log("fileArr"+JSON.stringify(this.fileArr))
                          }else if(item.type == 'file'){
                            this.$set(this.fileArr, item.value,list.map((e)=>({
                              attachName: e.attachName,
                              filePath: e.filePath,
                              fileType: e.attachType,
                              fileSize: this.convertFileSize(e.attachSize)     //文件单位转换
                            })) )

                          }else{
                            this.$set(this.fileArr, item.value,list)
                          }
                      })
                    }
                }else if(item.type == 'image'){ //groupUrl的图片类型
                   let photosList = []
                      photosList.push({
                          filePath: this.detailForm[item.value],
                          createDate: '',
                          //createDate: this.detailForm['createTime']
                      })
                    this.$set(this.fileArr, item.value, photosList)
                }
          });
        this.$forceUpdate();
   },
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.con-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 0.2rem;
  .each {
    width: 33.33%;
    line-height: 0.5rem;
    /deep/ .value {
      color: #444;
    }
    .p{ //设置内容段落样式
      line-height: 0.3rem;
      display: block;
      padding-top: 0.1rem;
      /*color: #444;*/
    }
  }
}
.filename{
  @include table_font_color($table-btn-colorD);
  &:hover{
    cursor: pointer;
    @include table_btn_color($table-btn-hoverD);
  }
}
.size{
    color: #666;
}

//主图样式
// .main-img{
//    width: 1.18rem;
//   height:0.78rem;
//   margin:0.1rem 0.1rem 0 0;
//   cursor: pointer;
// }
/deep/ .key{
  width:1.4rem;
  text-align: right;
  line-height: 0.5rem;
  //color: #666;
  color:#555;
}
/deep/ .value {
    color: #444;
}
//备注样式
.tips {
  display: flex;
  align-items: center;
  cursor: pointer;
  img{
    width: .16rem;
    @include top_desc_img('tip.png');
  }
}
//超链接样式
.links {
  display: flex;
  align-items: center;
  cursor: pointer;
  img{
    width: .16rem;
    @include top_desc_img('tip.png');
  }
  span{
    @include table_font_color($table-btn-colorD);
    margin-left: 0.06rem;
    text-decoration:underline;
    &:hover{
      @include table_btn_color($table-btn-hoverD);
    }
  }
}
.table-desc {
  width: 100%;
  padding-left: .14rem;
  padding-right: .2rem;
  margin: 0;
  height: .4rem;
  line-height: .4rem;
  display: flex;
  justify-content: space-between;
  @include top_desc_bg($top-desc-bgD);
  @include top_desc_border($top-desc-borderD);
  span {
    // font-size: .16rem;
    // font-family: Microsoft YaHei;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EXDetail/EXDetailContent.vue